import PropTypes from 'prop-types';
import React from 'react';
import { ArrowRightShort } from 'react-bootstrap-icons';

import useArticle from '../../hooks/use_article';
import useGroup from '../../hooks/use_group';
import useTranslation from '../../hooks/use_translation';
import { getVariantByLanguage } from '../../utils/helpers';
import Btn from '../framework/buttons/btn';
import SymptomListItem from './list-item';

const SymptomList = ({
	children,
	exclude_articles,
	include_groups,
	include_markers,
}) => {
	let empty = true;
	const { language } = useTranslation('component_symptom_list');

	const { items: articles } = useArticle({
		exclude_articles,
		include_markers,
		include_types: ['symptom'],
	});
	const { items: groups_data } = useGroup({ include_groups });

	const component = (
		<section id="articles">
			{groups_data.map((group, index1) => {
				const articles_filtered = articles.filter((article) => {
					return article.groups.includes(group.group_id);
				});
				if (!articles_filtered || !articles_filtered.length) return;

				const group_variant = getVariantByLanguage(
					language,
					group.group_variants,
				);
				if (!group_variant) return;
				if (empty) empty = false;
				const article_list = articles_filtered.map((article, index2) => {
					const variant = getVariantByLanguage(
						language,
						article.article_variants,
					);
					if (!variant) return;

					return (
						<div className="col-lg-6 mb-lg-2 mb-1" key={index2}>
							<SymptomListItem
								article_id={article.article_id}
								excerpt={variant.excerpt}
								groups={article.groups}
								slug={variant.slug}
								subtitle={variant.subtitle}
								title={variant.title}
							/>
						</div>
					);
				});

				if (!article_list || !article_list.length) return;

				return (
					<div className="article-list-group" key={index1}>
						{(!include_groups ||
							(include_groups && include_groups.length > 1)) && (
							<Btn
								className="mb-2 mt-4 text-dark"
								component="group_link"
								groups={[group.group_id]}
								labelType="h2"
								page="symtom"
								rightSection={<ArrowRightShort />}
								size="title_small"
								variant="link"
							>
								{group_variant.title}
							</Btn>
						)}
						<div className="row">{article_list}</div>
					</div>
				);
			})}
		</section>
	);
	return children ? <>{children(empty ? null : component)}</> : component;
};

SymptomList.propTypes = {
	children: PropTypes.any,
	exclude_articles: PropTypes.array,
	include_groups: PropTypes.array,
	include_markers: PropTypes.array,
};

export default SymptomList;
